<template>
    <v-dialog
        v-model="addBillingCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType==='Add'"
                class="ma-1 action-btn text-subtitle-2"
                depressed
                color="primary"
                v-bind="attrs"
                @click="openDialog"
            >
                <v-icon
                    left
                    class="action-icon"
                >
                    mdi-plus
                </v-icon>
                Add Billing Code
            </v-btn>
            <v-icon
                v-if="modelType==='Edit'"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil
            </v-icon>
        </template>
        <v-card id="add_member_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span v-if="modelType === 'Add'">Add Billing Code</span>
                <span v-if="modelType === 'Edit'">Edit Billing Code</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <v-form
                    ref="form"
                    v-model="formValid"
                >
                    <v-row class="mt-5">
                        <v-col
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="addBillingCodeDialog"
                                v-model="code"                                
                                label="Billing Code"
                                :rules="billingCodeRules"
                                outlined
                                dense
                                class="upper-case"
                                required
                            />                           
                        </v-col>
                        <v-col
                            cols="12"
                            sm="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="addBillingCodeDialog"
                                v-model="description"                                
                                label="Description"
                                :rules="descriptionRules"
                                outlined
                                dense
                                class="upper-case"
                                required
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            md="12"
                            class="py-0"
                        >
                            <v-text-field
                                v-if="addBillingCodeDialog"
                                v-model="amount"
                                label="Amount"
                                :rules="amountRules"
                                outlined
                                dense
                                class="upper-case"
                                required
                            />
                        </v-col>                       
                    </v-row>                             
                </v-form>                
            </v-card-text>
            <v-divider />
            <v-card-actions>               
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    :disabled="!addBillingCodeDialog || !code || !description || !amount"
                    @click="save"
                >
                    <span v-if="modelType==='Add'">Add</span>
                    <span v-if="modelType==='Edit'">Update</span>
                </v-btn>
            </v-card-actions>           
        </v-card>
    </v-dialog>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import CompanyBillingMixin from '@/mixins/CompanyBillingMixin';
export default {
    mixins: [
        CompanyBillingMixin,
    ],
    props: {
        billingCodeDetails: {
            type: Object,
            default: () => {},
        },
        modelType: {
            type: String,
            default: '',
        },
    }, 
    data: () => ({
        addBillingCodeDialog: false,
        code: '',
        description: '',
        amount: '',
        formValid: false,       
    }),
    watch: {
        billingCodeDetails: {
            handler() {
                this.code = this.billingCodeDetails.code;
                this.description = this.billingCodeDetails.description;
                this.amount = this.billingCodeDetails.amount;                
            },
            deep: true,
        },
    },
    created() {
        this.resetFormData();        
    },
    mounted() {
        if(this.billingCodeDetails) {
            this.code = this.billingCodeDetails.code;
            this.description = this.billingCodeDetails.description;
            this.amount = this.billingCodeDetails.amount;            
        }
    },
    methods: {
        openDialog(){
            this.addBillingCodeDialog = true;
        },
        closedDialog() {
            // this.resetFormData();
            this.addBillingCodeDialog = false;
        },
        capitalized(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        resetFormData() {
            this.code = '';
            this.description = '';
            this.amount = '';
            this.formValid = false;
            if(this.billingCodeDetails) {
                this.code = this.billingCodeDetails.billingCode;
                this.description = this.billingCodeDetails.description;
                this.amount = this.billingCodeDetails.amount;               
            }
        },
        async save() {
            let response = {};
            this.$refs.form.validate();
            if (this.formValid && this.modelType === 'Add') {
                let data = {
                    code: this.code,
                    description: this.description,
                    amount: this.amount.toString(),
                };

                response = await webtmsBackend.addBillingCode(data);
            }else if (this.formValid && this.modelType === 'Edit') { 
                
                let data = {
                    rowid: this.billingCodeDetails.rowid,
                    code: this.code,
                    description: this.description,
                    amount: this.amount.toString(),
                };
                response = await webtmsBackend.updateBillingCode(data);
            }
                  
            if(response.result.result === 'ERR') {
                this.$store.dispatch('setSnackbar', { color:'error', text: response.result.message });
            }else if(response.result.result === 'OK') {
                this.$store.commit('SET_COMPANY_BILLING', response.billing);                
                this.$store.dispatch('setSnackbar', { text: response.result.message, color:'success' });
            }
            this.resetFormData();
            this.addBillingCodeDialog = false;
        }
    },    
};
</script>

<style>
</style>